"use client";

import React, { useEffect, useState } from "react";
import { businessData } from "@/data/business";
import { usePathname } from "next/navigation";
import { useQuery } from "convex/react";
import { api } from "@/convex/_generated/api";

export function FloatingActions() {
  const pathname = usePathname();
  const [showTop, setShowTop] = useState(false);
  const convexConfigured = Boolean(process.env.NEXT_PUBLIC_CONVEX_URL);
  const settings = useQuery(api.siteSettings.getPublic, convexConfigured ? {} : "skip");
  const configuredWidget = settings?.floating_widget;
  const widgetEnabled = configuredWidget ? configuredWidget.enabled === true : true;
  const widgetPosition = configuredWidget?.position || "right";

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 300) {
        setShowTop(true);
      } else {
        setShowTop(false);
      }
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = (e: React.MouseEvent) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (pathname.startsWith("/admin") || pathname === "/login") return null;

  return (
    <nav
      className="floating-actions"
      aria-label="Quick actions"
      style={widgetEnabled ? (widgetPosition === "right" ? { right: "auto", left: "16px" } : { right: "16px", left: "auto" }) : undefined}
    >
      {!widgetEnabled && <a
        className="floating-action floating-whatsapp"
        href={`https://wa.me/${businessData.contact.whatsapp}`}
        target="_blank"
        rel="noopener"
        aria-label="Chat with Shaaira Biocare on WhatsApp"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M3 21l1.65-3.8a9 9 0 1 1 3.4 2.9L3 21" />
          <path d="M9 10a.5.5 0 0 0 1 0V9a.5.5 0 0 0-1 0v1a5 5 0 0 0 5 5h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1" />
        </svg>
      </a>}
      <a
        className={`floating-action floating-top ${showTop ? "is-visible" : ""}`}
        href="#main"
        onClick={scrollToTop}
        aria-label="Back to top"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M12 19V5M6 11l6-6 6 6" />
        </svg>
      </a>
    </nav>
  );
}
